import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SecurityIcon from '@mui/icons-material/Security';
import StarIcon from '@mui/icons-material/Star';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const FeatureCard = ({ title, icon, description }) => {
    const theme = useTheme();
    return (
        <Paper
            elevation={0}
            sx={{
                p: 4,
                textAlign: 'center',
                background: 'rgba(20, 20, 20, 0.6)',
                border: '1px solid rgba(255, 215, 0, 0.1)',
                borderRadius: '20px',
                height: '100%',
                transition: 'all 0.3s',
                '&:hover': {
                    background: 'rgba(30, 30, 30, 0.8)',
                    border: `1px solid ${theme.palette.secondary.main}`,
                    transform: 'translateY(-5px)',
                    boxShadow: `0 0 20px rgba(255, 215, 0, 0.2)`
                }
            }}
        >
            <Box sx={{
                color: theme.palette.secondary.main,
                mb: 2,
                '& svg': { fontSize: '3rem' }
            }}>
                {icon}
            </Box>
            <Typography variant="h5" gutterBottom sx={{ color: '#fff', fontWeight: 600 }}>
                {title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
                {description}
            </Typography>
        </Paper>
    );
};

const AboutSection = () => {
    const theme = useTheme();

    return (
        <Box sx={{ py: 10, background: '#000' }}>
            <Container maxWidth="lg">
                <Typography
                    variant="h2"
                    align="center"
                    gutterBottom
                    sx={{
                        textTransform: 'uppercase',
                        mb: 6,
                        background: `linear-gradient(45deg, ${theme.palette.secondary.main}, #fff)`,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                >
                    Why Choose Us
                </Typography>

                <Typography
                    variant="h5"
                    align="center"
                    sx={{
                        maxWidth: '800px',
                        mx: 'auto',
                        mb: 8,
                        color: 'rgba(255,255,255,0.9)',
                        lineHeight: 1.8
                    }}
                >
                    ESCOBAR Online's accomplishments in expertise, innovation, and security make it a standout performer in the rapidly evolving iGaming and betting industry.
                </Typography>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <FeatureCard
                            title="Expertise"
                            icon={<StarIcon />}
                            description="Years of experience delivering top-tier betting experiences across multiple platforms."
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FeatureCard
                            title="Innovation"
                            icon={<TrendingUpIcon />}
                            description="Constantly evolving technology to bring you the smoothest and most engaging gameplay."
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FeatureCard
                            title="Security"
                            icon={<SecurityIcon />}
                            description="State-of-the-art encryption and security measures to ensure your data and funds are always safe."
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default AboutSection;
